<template>
  <Calendar 
    :isNeedSmallCalendar="true"
    :isNeedTags="true"
  />
</template>

<script>
import Calendar from "@components/calendar/Calendar";

export default {
  name: "CalendarPage",

  components: {
    Calendar,
  },
};
</script>

